import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SaveProjectService } from 'src/app/core/services/save-project.service';
import { ModalOverlayRef } from 'src/app/modal/modal-overlay-ref';
import { UserApiService } from '../../core/services/user-api.service';
import { ProjectService } from '../../core/services/project.service';
import { Project } from '../../core/objects/project';
import { ProjectApiService } from 'src/app/core/services/project-api.service';
import { MessageService } from '../../core/services/message.service';

@Component({
    selector: 'gl-save-project',
    templateUrl: './save-project.component.html',
    styleUrls: ['./save-project.component.scss'],
    standalone: false
})
export class SaveProjectComponent implements OnInit {
  public form: UntypedFormGroup;
  public projectDescription: string;
  public project: Project;
  public isEmapaActive = false;
  public isCompanyShared = true;

  constructor(
    private modalRef: ModalOverlayRef,
    private userApiService: UserApiService,
    private saveProjectService: SaveProjectService,
    public projectService: ProjectService,
    private projectApiService: ProjectApiService,
    private messageService: MessageService,
  ) {
    this.projectDescription = this.saveProjectService.generateVisibleDescription();
    this.modalRef.backgroundClicked();
  }

  public generateForm(): UntypedFormGroup {
    return new UntypedFormGroup({
      projectTitle: new UntypedFormControl(this.saveProjectService.generateDefaultProjectName(), [
        Validators.required,
        Validators.maxLength(255),
      ]),
      note: new UntypedFormControl('', [Validators.maxLength(500)]),
    });
  }

  public ngOnInit(): void {
    this.form = this.generateForm();
    this.projectService.project.subscribe((project: Project): void => {
      this.project = project;
      this.isEmapaActive =
        this.projectService.isEmapa &&
        project.workSpaces[0]?.cargoSpaces[0]?.type !== 3 &&
        project.workSpaces?.length < 2;
    });
    this.projectApiService.getProjectInfo().subscribe(() => {
      if (this.projectApiService.currentProjectName) {
        this.form.controls['projectTitle'].setValue(this.projectApiService.currentProjectName);
      }
      if (this.projectApiService.currentProjectName) {
        this.form.controls['note'].setValue(this.projectApiService.currentProjectNote);
      }
    });
  }

  public onClose(): void {
    this.modalRef.close();
  }

  public saveProject(): void {
    if (this.form.valid) {
      const projectData = {
        description: this.saveProjectService.generateProjectDescription(),
        name: this.form.get('projectTitle').value
          ? (this.form.get('projectTitle').value as string)
          : '',
        note: this.form.get('note').value ? (this.form.get('note').value as string) : '',
      };
      this.userApiService.saveProject(projectData).subscribe((): void => {
        if (this.isCompanyShared) {
          this.projectApiService.shareCompany(projectData).subscribe((): void => {
            this.messageService.sendMessage({ name: 'savedProject' });
            this.modalRef.close();
          });
        } else {
          this.messageService.sendMessage({ name: 'savedProject' });
          this.modalRef.close();
        }
      });
    }
  }
}
